<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
    import { Icon } from '@oat-sa-private/ui-elements';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    /**
     * Component to be provided to DataTable headers to show a clickable icon in a column's cells
     *
     * @property {Object} data
     * @property {String} [data.actionType] - name of the event type it will fire
     * @property {String} [data.title] - title (text displayed as tooltip)
     * @property {String} [data.icon] - name of the icon
     * @property {Boolean} [data.hidden] - do not render this icon button
     * @property {Boolean} [data.disabled] - disable the button
     */
    export let data;
</script>

<style>
    .icon-button {
        position: relative;
        padding: 0 0.5rem;
        cursor: pointer;

        &[aria-disabled=true] {
            cursor: not-allowed;
        }

        /* hitbox */
        &:before {
            position: absolute;
            top: -0.5rem;
            left: -1rem;
            width: 5.5rem;
            height: 5.5rem;
            content: '';
        }
    }
    :global(.icon-button:focus-visible) {
        @add-mixin outline-focus -1rem;
    }
</style>

{#if !data.hidden}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
        class="icon-button"
        role="button"
        title={data.title}
        tabindex={data.disabled ? void 0 : '0'}
        aria-label={data.title}
        aria-disabled={data.disabled}
        on:click={evt => {
            evt.stopPropagation();
            if (!data.disabled) {
                dispatch('action', { type: data.actionType || 'click' });
            }
        }}>
        <Icon name={data.icon} />
    </div>
{/if}
